import { MESApiService, type spParameter } from "@dexteel/mesf-core";

type getDelaysForParetoProps = {
  startDate: Date;
  endDate: Date;
  delayCodeId?: number | null;
  delayCategoryId?: number | null;
  shiftId?: number | null;
  crew?: string | null;
  delayAreaAssetId?: number | null;
  includeMicroDelays: boolean;
  includeUndeclaredDelays: boolean;
  signal?: AbortSignal;
};

export const getDelaysForPareto = async ({
  startDate,
  endDate,
  delayCodeId,
  delayCategoryId,
  shiftId,
  crew,
  delayAreaAssetId,
  includeMicroDelays = false,
  includeUndeclaredDelays = false,
  signal,
}: getDelaysForParetoProps) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "Start", value: startDate },
    { name: "End", value: endDate },
    {
      name: "DelayAreaAssetId",
      value: delayAreaAssetId || null,
    },
    {
      name: "DelayCategoryId",
      value: delayCategoryId || null,
    },
    {
      name: "DelayCodeId",
      value: delayCodeId || null,
    },
    {
      name: "ShiftId",
      value: shiftId || null,
    },
    {
      name: "Crew",
      value: crew || null,
    },
    {
      name: "IncludeMicrodelays",
      value: includeMicroDelays,
    },
    {
      name: "IncludeUndeclared",
      value: includeUndeclaredDelays,
    },
  ];

  return await apiService.callV2(
    "[DEL].[GetDelaysForPareto]",
    parameters,
    signal,
  );
};
